import { useEffect, useState } from 'react';

import { IntervalType, IntervalValue } from '@client/api';

const mapInteralValueToIntervalOption = (interval: IntervalValue | undefined | null): IntervalOption | undefined => {
  if (interval?.count == null && interval?.type == null) return undefined;

  if (interval.type === 'Year') {
    switch (interval.count) {
      case 1:
        return 'Yearly';
      default:
        return 'Custom'
    }
  } else if (interval.type === 'Month') {
    switch (interval.count) {
      case 1:
        return 'Monthly';
      case 2:
        return 'EveryTwoMonth';
      case 3:
        return 'EveryThreeMonth';
      case 4:
        return 'EveryFourMonth';
      case 5:
        return 'EveryFiveMonth';
      case 6:
        return 'EverySixMonth';
      default:
        return 'Custom'
    }
  }

  // if `interval.type` is nullable but `interval.count` exists
  return 'Custom';
}

export type IntervalOption = 'Monthly' | 'EveryTwoMonth' | 'EveryThreeMonth' | 'EveryFourMonth' | 'EveryFiveMonth' | 'EverySixMonth' | 'Yearly' | 'Custom';

export type UseIntervalOptionProps = {
  interval?: IntervalValue;
  onUpdateIntervalOption?: ({ intervalCount, intervalType }: { intervalCount: number | undefined, intervalType: IntervalType | undefined }) => void
}

/* export type UseIntervalOptionReturn = {

} */

export const useIntervalOption = ({ interval: intervalValue, onUpdateIntervalOption }: UseIntervalOptionProps) => {

  const [intervalOption, setIntervalOption] = useState<IntervalOption | undefined>(mapInteralValueToIntervalOption(intervalValue));

  const updateIntervalOption = (updatedIntervalOption: IntervalOption) => {
    setIntervalOption(updatedIntervalOption);

    let intervalType: IntervalType | undefined;
    let intervalCount: number | undefined;

    switch (updatedIntervalOption) {
      case 'Monthly':
        intervalCount = 1;
        intervalType = 'Month';
        break;
      case 'EveryTwoMonth':
        intervalCount = 2;
        intervalType = 'Month';
        break;
      case 'EveryThreeMonth':
        intervalCount = 3;
        intervalType = 'Month';
        break;
      case 'EveryFourMonth':
        intervalCount = 4;
        intervalType = 'Month';
        break;
      case 'EveryFiveMonth':
        intervalCount = 5;
        intervalType = 'Month';
        break;
      case 'EverySixMonth':
        intervalCount = 6;
        intervalType = 'Month';
        break;
      case 'Yearly':
        intervalCount = 1;
        intervalType = 'Year';
        break;
    }

    if (typeof onUpdateIntervalOption === 'function' && updatedIntervalOption !== 'Custom') {
      onUpdateIntervalOption({ intervalCount, intervalType })
    }
  };

  useEffect(() => {
    setIntervalOption(mapInteralValueToIntervalOption(intervalValue));
  }, [intervalValue])

  return {
    intervalOption,
    updateIntervalOption,
    setIntervalOption
  }
};
